export default function Pagination({ page, total, onChange, className = '' }) {
  if (total <= 1) return null
  return (
    <div className={`flex items-center justify-center gap-2 mt-6 ${className}`}>
      <button
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-3 py-1.5 rounded-lg text-sm bg-surface2 text-fg disabled:opacity-40 hover:bg-surface3 transition-colors"
      >←</button>
      <span className="text-sm text-muted">{page} / {total}</span>
      <button
        onClick={() => onChange(Math.min(total, page + 1))}
        disabled={page === total}
        className="px-3 py-1.5 rounded-lg text-sm bg-surface2 text-fg disabled:opacity-40 hover:bg-surface3 transition-colors"
      >→</button>
    </div>
  )
}
